import { SHOP_TYPE_TAOBAO } from '@/constants/retailPlatform'

export default {
	computed: {
		isTaobao() {
			if (this.$route && this.$route.path.indexOf('/StoreConfig/taobao/') === 0) {
				return true
			}
			const detail = this.retailShop && this.retailShop.shopDetail
			return !!(detail && Number(detail.type) === SHOP_TYPE_TAOBAO)
		},
		platformName() {
			return this.isTaobao ? '淘宝' : '拼多多'
		},
		platformShopNameLabel() {
			return this.platformName + '店铺名称'
		},
		platformShopColumnLabel() {
			return this.platformName + '店铺'
		},
		platformDeductionLabel() {
			return this.platformName + '扣点数 (%)'
		},
		priceRangeLabel() {
			return this.isTaobao ? '商品价格区间 (元)' : '拼多多拼单价区间 (元)'
		},
		priceUnitLabel() {
			return this.isTaobao ? '商品价格' : '拼单价'
		},
	},
	methods: {
		withPlatformName(text) {
			if (!text) {
				return text
			}
			if (!this.isTaobao) {
				return text
			}
			return String(text).split('拼多多').join('淘宝')
		},
	},
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/taobaoPlatformMixin.js